import { Literal, Static, Union } from "runtypes";

/**
 * Canonical reasoning-effort vocabulary.
 *
 * Currently, `none` and `minimal` are reachable only via internally-configured
 * static configs. The picker derives its per-model subset from
 * `MODEL_CLIENT_STATIC_CONFIGS`, so widening this union doesn't widen the
 * UI surface on its own.
 */
export const EffortLevelLiteral = Union(
  Literal("none"),
  Literal("minimal"),
  Literal("low"),
  Literal("medium"),
  Literal("high"),
  Literal("xhigh"),
  Literal("max"),
);
export type EffortLevel = Static<typeof EffortLevelLiteral>;

export const EFFORT_LEVEL_LABELS: Record<EffortLevel, string> = {
  none: "None",
  minimal: "Minimal",
  low: "Low",
  medium: "Medium",
  high: "High",
  xhigh: "Extra high",
  max: "Max",
};

/**
 * Provider-agnostic model speed selection. `fast` opts into higher output token
 * throughput on supported models (today only Anthropic fast mode on Opus 4.8,
 * Claude API only); `null`/absent means standard. This is intentionally a small
 * shared vocabulary so persistence, GraphQL, the picker, and the Anthropic wire
 * param all use a single type.
 * @see https://platform.claude.com/docs/en/build-with-claude/fast-mode
 */
export const ModelSpeedLiteral = Union(Literal("standard"), Literal("fast"));
export type ModelSpeed = Static<typeof ModelSpeedLiteral>;
